/* global axios */
import ApiClient from './ApiClient';

class InstagramAutomationAPI extends ApiClient {
  constructor() {
    super('instagram', { accountScoped: true });
  }

  getConnection() {
    return axios.get(`${this.url}/automation_connection`);
  }

  saveConnection(data) {
    return axios.post(`${this.url}/automation_connection`, data);
  }

  deleteConnection() {
    return axios.delete(`${this.url}/automation_connection`);
  }

  media() {
    return axios.get(`${this.url}/automation_connection/media`);
  }

  health() {
    return axios.get(`${this.url}/automation_connection/health`);
  }

  managedAccounts() {
    return axios.get(`${this.url}/automation_connection/managed_accounts`);
  }

  listAutomations() {
    return axios.get(`${this.url}/automations`);
  }

  createAutomation(automation) {
    return axios.post(`${this.url}/automations`, { automation });
  }

  updateAutomation(id, automation) {
    return axios.put(`${this.url}/automations/${id}`, { automation });
  }

  deleteAutomation(id) {
    return axios.delete(`${this.url}/automations/${id}`);
  }

  // dry-run: simula um comentário contra a automação sem enviar nada
  previewAutomation(id, text) {
    return axios.post(`${this.url}/automations/${id}/preview`, { text });
  }
}

export default new InstagramAutomationAPI();
